export default function disableSoftEnter(editor) {
  editor.editing.view.document.on('enter', (event, data) => {
    if (!data.domEvent.shiftKey) {
      data.preventDefault();
      event.stop();
    }
  });
}
